<template>
  <div class="page-pizzas">
    <div class="navigation-wrapper">
    <TopNavbar></TopNavbar>
      <navbar />
      <AlertBox></AlertBox>
      </div>
      <Header :background_image="backgroundImage">
          <template 
            v-slot:title>
              PIZZE IZ KRUŠNE PEČI
          </template>
          <template 
            v-slot:subtitle>
              vsak dan, za vse okuse
          </template>
      </Header>
      <DeliveryBanner></DeliveryBanner>

      <Intro>
        <template 
          v-slot:description>
            Naše pizze pečemo v krušni peči na temperaturi 400°Celzija, kar omogoča hitro pečenje in
posledično odličen okus. Vedno poskrbimo tudi za kvalitetna drva – ne boste verjeli, a tudi to je
pomembno, da so pizze res dobre. Pomembno pa je seveda <strong>testo, ki ga pripravljamo že vsa leta po
istem receptu, saj so takega vzljubile naše stalne stranke</strong>. Sledi izbira kakovostnih in svežih surovin,
spretne roke naših picopekov in…..<strong>odlična pizza</strong> je pred vami :)
        </template>
        <template 
          v-slot:title-last>
            ...pa dober tek!
        </template>
        <template 
          v-slot:image-11>
            <img src="../assets/tab1.png">
        </template>
        <template 
          v-slot:image-1>
            Hrustljavo zapečene v krušni peči
        </template>
        <template 
          v-slot:image-22>
            <img src="../assets/tab2.png">
        </template>
        <template 
          v-slot:image-2>
           Sočne in bogato obložene
        </template>
        <template 
          v-slot:image-33>
            <img src="../assets/tab3.png">
        </template>
        <template 
          v-slot:image-3>
            Božanskega okusa
        </template>
        
      </Intro>
      <Tabs :labels="this.labels" title="Pizze" :isDelivery="false">
        <template 
          v-slot:mainTitle>
          Vse pizze
        </template>
      </Tabs>
      <Guests :testimonials="testimonials" :gallery="gallery"></Guests>
      <Footer></Footer> 
      <cookieConsent></cookieConsent>
  </div>
</template>

<style lang="scss">

@import '../components/variables.scss';

.page-pizzas {
    .subpage-header {
        background-image: url('../assets/pizza-header.jpg');
        margin-top:120px;
    }

    .pizzas-content {
        width:100%;
        max-width:1200px;
        margin:0 auto;
        padding: 1em;
        box-sizing: border-box;

        .pizzas-intro {
            margin:4em 0 0 0;
            line-height: 2;
            text-align: left;
            @include screen('mobile') {
              margin:2em auto;
            }
        }
    }
}
</style>

<script>
import backgroundImage from '@/assets/krušnapeč-min.png'
import TopNavbar from "@/components/TopNavbar/TopNavbar"
import Navbar from "@/components/MainNavbar/Navbar"
import Header from "@/components/Header/Header"
import DeliveryBanner from "@/components/DeliveryBanner/DeliveryBanner"
import Intro from "@/components/Intro/Intro"
// import MenuSection from "@/components/MenuSection/MenuSection"
import Footer from "@/components/Footer/Footer"
import Guests from "@/components/Guests/Guests"
import AlertBox from "@/components/AlertBox/AlertBox"
import Tabs from "@/components/Tabs.vue"
import cookieConsent from "@/components/cookieConsent.vue"
export default {
  name: "Home",
  data: () => ({
      backgroundImage,
      testimonials: [
        { name: 'Danijel H.', message: 'Najboljše pizze v Kamniku!'},
        { name: 'Tomaž K.', message: 'Konstantno dobra kvaliteta surovin.Sam naročam polpol kmečka-interblock. Top!'},
        { name: 'Rok S.', message: 'Pice so sicer odlične, ampak je postrežba in družba še boljša!'}
      ],
      labels: [
            {
                label: 'Pizze',
                id: 3
            },
            {
                label: 'Hišne pizze',
                id: 5
            },
            {
                label: 'Morske pizze',
                id: 6
            },
            {
                label: 'Vegetarijanske pizze',
                id: 7
            },
            {
                label: 'Dodatki',
                id: 8
            }
        ]
  }),
  components: {
    // PizzaList
      TopNavbar,
      Navbar,
      AlertBox,
      Header,
      DeliveryBanner,
      Intro,
      // MenuSection,
      Guests,
      Footer,
      Tabs,
      cookieConsent
  },
  computed: {
        meals() {
        return this.$store.getters.allMeals
        },
        gallery() {
			return this.$store.getters.allGalleryAllPizzas
		},
	},
	mounted() {
        this.$store.dispatch("getMeals")
        this.$store.dispatch("getGalleryAllPizzas")
	},
};
</script>
